import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { formatNumber } from '~/assets/helper/functions';
import { formatAsGermanDate } from '~/functions/helpers';
import { ghgImpactSolutions, impactSolutionMetricValues, roundValue } from '~/functions/ghg';
import { impactResultCardEditPath } from '~/functions/impact-result-card-edit';
import { getLocale } from '~/functions/translate';
import { useGetImpactSummaryQuery, useListEvidenceLinksQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'GhgResults',
  props: {
    climateImpact: null,
    ventureId: null,
    ghgStartingYear: {
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var editPath = computed(function () {
      return impactResultCardEditPath(props.ventureId, props.climateImpact);
    });
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var climateImpact = computed(function () {
      return props.climateImpact;
    });
    var _useGetImpactSummaryQ = useGetImpactSummaryQuery({
        ventureId: props.ventureId
      }, {
        fetchPolicy: 'cache-and-network'
      }),
      impactSummaryResult = _useGetImpactSummaryQ.result,
      summaryLoading = _useGetImpactSummaryQ.loading;
    var impactSummary = computed(function () {
      var _impactSummaryResult$, _impactSummaryResult$2;
      return (_impactSummaryResult$ = (_impactSummaryResult$2 = impactSummaryResult.value) === null || _impactSummaryResult$2 === void 0 ? void 0 : _impactSummaryResult$2.getImpactSummary) !== null && _impactSummaryResult$ !== void 0 ? _impactSummaryResult$ : null;
    });
    var ghgMetricValues = computed(function () {
      var _impactSummary$value$, _impactSummary$value;
      return (_impactSummary$value$ = (_impactSummary$value = impactSummary.value) === null || _impactSummary$value === void 0 ? void 0 : _impactSummary$value.ghgMetricValues) !== null && _impactSummary$value$ !== void 0 ? _impactSummary$value$ : null;
    });
    var ghgSolutions = computed(function () {
      return ghgImpactSolutions(climateImpact.value);
    });
    var ghgChartSolutionSeries = computed(function () {
      return ghgSolutions.value.map(function (solution) {
        var _solution$concept;
        return {
          name: ((_solution$concept = solution.concept) === null || _solution$concept === void 0 ? void 0 : _solution$concept.label) || 'Solution',
          metricValues: impactSolutionMetricValues(solution, climateImpact.value)
        };
      }).filter(function (series) {
        return series.metricValues.length > 0;
      });
    });
    var ghgSolutionIds = computed(function () {
      return ghgSolutions.value.map(function (solution) {
        return solution.id;
      }).filter(function (id) {
        return typeof id === 'number';
      });
    });
    var evidenceVariables = computed(function () {
      return {
        filters: {
          accountId: props.ventureId,
          entityIntIds: ghgSolutionIds.value,
          type: 'impact-solution'
        },
        limit: 1000,
        offset: 0
      };
    });
    var _useListEvidenceLinks = useListEvidenceLinksQuery(evidenceVariables, computed(function () {
        return {
          enabled: ghgSolutionIds.value.length > 0
        };
      })),
      evidenceResult = _useListEvidenceLinks.result;
    function groupEvidenceByEntityId(evidenceLinks) {
      return (evidenceLinks !== null && evidenceLinks !== void 0 ? evidenceLinks : []).reduce(function (acc, evidenceLink) {
        if (!evidenceLink || evidenceLink.entityIntId == null) return acc;
        var entityId = evidenceLink.entityIntId;
        if (!acc[entityId]) acc[entityId] = [];
        acc[entityId].push(evidenceLink);
        return acc;
      }, {});
    }
    var evidenceBySolutionId = computed(function () {
      var _evidenceResult$value;
      return groupEvidenceByEntityId((_evidenceResult$value = evidenceResult.value) === null || _evidenceResult$value === void 0 ? void 0 : _evidenceResult$value.listEvidenceLinks);
    });
    function solutionEvidenceLinks(solutionId) {
      var _evidenceBySolutionId;
      if (solutionId == null) return [];
      return (_evidenceBySolutionId = evidenceBySolutionId.value[solutionId]) !== null && _evidenceBySolutionId !== void 0 ? _evidenceBySolutionId : [];
    }
    var updatedOnLabel = computed(function () {
      var _climateImpact$value;
      var submitDate = (_climateImpact$value = climateImpact.value) === null || _climateImpact$value === void 0 ? void 0 : _climateImpact$value.submitDate;
      if (!submitDate) return null;
      var formatted = formatAsGermanDate(String(submitDate));
      if (!formatted) return null;
      return String(proxy.$t('updatedOn', {
        date: formatted
      }));
    });
    var programmePeriod = computed(function () {
      var _ghgMetricValues$valu, _ref2, _ref3, _climateImpact$value$, _climateImpact$value2, _ref4, _climateImpact$value$2, _climateImpact$value3;
      var metricYears = ((_ghgMetricValues$valu = ghgMetricValues.value) !== null && _ghgMetricValues$valu !== void 0 ? _ghgMetricValues$valu : []).map(function (metricValue) {
        return Number.parseInt(String(metricValue.period), 10);
      }).filter(function (year) {
        return Number.isFinite(year);
      }).sort(function (a, b) {
        return a - b;
      });
      var start = (_ref2 = (_ref3 = (_climateImpact$value$ = (_climateImpact$value2 = climateImpact.value) === null || _climateImpact$value2 === void 0 ? void 0 : _climateImpact$value2.startingYear) !== null && _climateImpact$value$ !== void 0 ? _climateImpact$value$ : props.ghgStartingYear) !== null && _ref3 !== void 0 ? _ref3 : metricYears[0]) !== null && _ref2 !== void 0 ? _ref2 : null;
      var years = (_ref4 = (_climateImpact$value$2 = (_climateImpact$value3 = climateImpact.value) === null || _climateImpact$value3 === void 0 ? void 0 : _climateImpact$value3.durationYears) !== null && _climateImpact$value$2 !== void 0 ? _climateImpact$value$2 : metricYears.length > 0 ? metricYears.length : null) !== null && _ref4 !== void 0 ? _ref4 : 5;
      if (!start || !years) return null;
      return {
        start: start,
        end: start + years - 1,
        years: years
      };
    });
    var periodRangeLabel = computed(function () {
      var period = programmePeriod.value;
      if (!period) return null;
      return String(proxy.$t('periodRange', period));
    });
    function formatGhgValue(value) {
      return formatNumber(roundValue(value !== null && value !== void 0 ? value : 0), getLocale());
    }
    function boldValueInText(text, formatted) {
      return text.replace(formatted, "<strong>".concat(formatted, "</strong>"));
    }
    var statusDescriptionDisplay = computed(function () {
      var period = programmePeriod.value;
      if (!period) return String(proxy.$t('statusDescriptionNoPeriod'));
      return String(proxy.$t('statusDescription', period));
    });
    var totalReductionDisplay = computed(function () {
      var _impactSummary$value2;
      return formatGhgValue((_impactSummary$value2 = impactSummary.value) === null || _impactSummary$value2 === void 0 ? void 0 : _impactSummary$value2.totalGhgReduction);
    });
    var averageAnnualDisplay = computed(function () {
      var _impactSummary$value3, _programmePeriod$valu;
      var value = (_impactSummary$value3 = impactSummary.value) === null || _impactSummary$value3 === void 0 ? void 0 : _impactSummary$value3.averageAnnualReduction;
      var years = (_programmePeriod$valu = programmePeriod.value) === null || _programmePeriod$valu === void 0 ? void 0 : _programmePeriod$valu.years;
      if (value == null || years == null) return null;
      var formatted = formatGhgValue(value);
      var text = String(proxy.$t('averageAnnualReduction', {
        value: formatted,
        years: years
      }));
      return boldValueInText(text, formatted);
    });
    var economicValueDisplay = computed(function () {
      var _impactSummary$value4;
      var value = (_impactSummary$value4 = impactSummary.value) === null || _impactSummary$value4 === void 0 ? void 0 : _impactSummary$value4.economicValue;
      if (value == null) return null;
      var formatted = formatGhgValue(value);
      var text = String(proxy.$t('economicValue', {
        value: formatted
      }));
      return boldValueInText(text, formatted);
    });
    var hasFrameworkContent = computed(function () {
      var _climateImpact$value$3, _climateImpact$value4, _climateImpact$value5, _climateImpact$value6, _climateImpact$value$4, _climateImpact$value7, _climateImpact$value8;
      return ((_climateImpact$value$3 = (_climateImpact$value4 = climateImpact.value) === null || _climateImpact$value4 === void 0 ? void 0 : (_climateImpact$value5 = _climateImpact$value4.sdgTargets) === null || _climateImpact$value5 === void 0 ? void 0 : _climateImpact$value5.length) !== null && _climateImpact$value$3 !== void 0 ? _climateImpact$value$3 : 0) > 0 || !!((_climateImpact$value6 = climateImpact.value) !== null && _climateImpact$value6 !== void 0 && _climateImpact$value6.euTaxonomy) || ((_climateImpact$value$4 = (_climateImpact$value7 = climateImpact.value) === null || _climateImpact$value7 === void 0 ? void 0 : (_climateImpact$value8 = _climateImpact$value7.irisCategories) === null || _climateImpact$value8 === void 0 ? void 0 : _climateImpact$value8.length) !== null && _climateImpact$value$4 !== void 0 ? _climateImpact$value$4 : 0) > 0;
    });
    var hasCardContent = computed(function () {
      return !!impactSummary.value && (ghgSolutions.value.length > 0 || ghgMetricValues.value && ghgMetricValues.value.length > 0 || impactSummary.value.totalGhgReduction != null);
    });
    return {
      __sfc: true,
      props: props,
      editPath: editPath,
      proxy: proxy,
      climateImpact: climateImpact,
      impactSummaryResult: impactSummaryResult,
      summaryLoading: summaryLoading,
      impactSummary: impactSummary,
      ghgMetricValues: ghgMetricValues,
      ghgSolutions: ghgSolutions,
      ghgChartSolutionSeries: ghgChartSolutionSeries,
      ghgSolutionIds: ghgSolutionIds,
      evidenceVariables: evidenceVariables,
      evidenceResult: evidenceResult,
      groupEvidenceByEntityId: groupEvidenceByEntityId,
      evidenceBySolutionId: evidenceBySolutionId,
      solutionEvidenceLinks: solutionEvidenceLinks,
      updatedOnLabel: updatedOnLabel,
      programmePeriod: programmePeriod,
      periodRangeLabel: periodRangeLabel,
      formatGhgValue: formatGhgValue,
      boldValueInText: boldValueInText,
      statusDescriptionDisplay: statusDescriptionDisplay,
      totalReductionDisplay: totalReductionDisplay,
      averageAnnualDisplay: averageAnnualDisplay,
      economicValueDisplay: economicValueDisplay,
      hasFrameworkContent: hasFrameworkContent,
      hasCardContent: hasCardContent
    };
  }
});